import type { TOC } from '@ember/component/template-only'
import { hash } from '@ember/helper'
import { LinkTo } from '@ember/routing'

interface Signature {
  Element: HTMLAnchorElement
  Args: {
    route: string
    query?: Record<string, unknown>
  }
  Blocks: {
    default: []
  }
}

export const BreadcrumbLinkTo: TOC<Signature> = <template>
  <LinkTo
    @route={{@route}}
    @query={{if @query @query (hash)}}
    class="text-dusty-black-250 hover:text-dusty-black-250 active:text-dusty-black-250 text-base font-medium hover:underline"
    ...attributes
  >{{yield}}</LinkTo>
</template>

export default BreadcrumbLinkTo
